import { React, PropTypes, Row, FelaComponent, Switch } from '../dependencies';

const rule = ({ small }) => ({
    fontSize: small ? '13px' : '16px',
    margin: '10px 0',

    '& .ant-switch': {
        margin: '0 10px',
    },
});

const PanelToggleItem = ({ title, isSelected, onToggle, small }) => (
    <FelaComponent
        rule={rule}
        small={small}
        render={({ className }) => (
            <Row type="flex" align="space-between" className={className}>
                {title}
                <Switch checked={isSelected} onChange={onToggle} size={small ? 'small' : 'default'} />
            </Row>
        )}
    />
);

PanelToggleItem.propTypes = {
    title: PropTypes.node.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    small: PropTypes.bool,
};

PanelToggleItem.defaultProps = {
    small: false,
};

export default PanelToggleItem;
